import StakingList from './StakingList';
import StakingListContainer from './StakingListContainer';

export default StakingList;
export { StakingListContainer };